import * as React from 'react'

import { styled } from '~/styled'
import { NavigatorActions } from '~/types/navigatorActions.types'
import { Override } from '~/utilities/types'
import { getExternalAnchorProps } from '~/utilities/uri'

export const StyledLink = styled(
  'a',
  {
    base: [
      'bg-[unset]',
      'text-primary-800',
      'cursor-pointer',
      'font-body',
      'no-underline',
      'focus:text-primary-900',
      'focus:underline',
      'hover:text-primary-900',
      'hover:underline',
      'active:text-primary-1000',
      'disabled:cursor-not-allowed',
      'disabled:opacity-30',
      'disabled:pointer-events-none',
      '[p>&,h1>&,h2>&,h3>&,h4>&,li>&,em>&]:after:content-none',
      '[p>&,h1>&,h2>&,h3>&,h4>&,li>&,em>&]:before:content-none',
      '[p>&,h1>&,h2>&,h3>&,h4>&,li>&,em>&]:text-[100%]/none'
    ],
    variants: {
      size: {
        xs: ['text-xs', 'leading-[1.6]', 'capsize-[0.4364]'],
        sm: ['text-sm', 'leading-[1.53]', 'capsize-[0.4056]'],
        md: ['text-md', 'leading-normal', 'capsize-[0.3864]'],
        lg: ['text-lg', 'leading-[1.52]', 'capsize-[0.3983]'],
        xl: ['text-xl', 'leading-[1.42]', 'capsize-[0.3506]']
      },
      noCapsize: {
        true: ['capsize-none']
      }
    },
    defaultVariants: {
      size: 'md'
    }
  },
  { enabledResponsiveVariants: true }
)

type LinkProps = Override<
  React.ComponentProps<typeof StyledLink>,
  NavigatorActions & { disabled?: boolean }
>

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ as, disabled, href, ...rest }, ref) => (
    <StyledLink
      as={as || (!href ? 'button' : undefined)}
      noCapsize={!href ? true : undefined}
      href={href}
      {...(disabled && { disabled: true })}
      {...rest}
      {...getExternalAnchorProps(href)}
      ref={ref as any}
    />
  )
)

Link.displayName = 'Link'
